import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { X, Loader2, PackageX } from "lucide-react";

const trTarih = (s) => { if (!s) return "—"; const p = String(s).slice(0, 10).split("-"); return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s; };
const fmtNum = (n) => Number(n || 0).toLocaleString("tr-TR");

export default function KaliteGecmeyenCell({ row }) {
  const v = Number(row.kaliteden_gecmeyen) || 0;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detay, setDetay] = useState([]);

  if (v <= 0) return <span className="text-zinc-400 font-bold">0</span>;

  const ac = async (e) => {
    e.stopPropagation();
    setOpen(true);
    setLoading(true);
    try {
      const r = await api.get("/dashboard/kaliteden-gecmeyen", { params: { urun_kodu: row.urun_kodu } });
      setDetay(r.data || []);
    } catch { toast.error("Detay yüklenemedi"); }
    finally { setLoading(false); }
  };

  const sorted = [...detay].sort((a, b) =>
    (a.durum === "gecikmis" ? 0 : 1) - (b.durum === "gecikmis" ? 0 : 1) ||
    String(a.tarih).localeCompare(String(b.tarih)));

  return (
    <>
      <button onClick={ac} data-testid={`kg-detay-btn-${row.id}`}
        className="font-bold text-orange-600 underline decoration-dotted underline-offset-2 hover:text-orange-700">
        {v.toLocaleString("tr-TR")}
      </button>
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4" onMouseDown={() => setOpen(false)}>
          <div className="bg-white rounded-md shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col" onMouseDown={(e) => e.stopPropagation()} data-testid="kg-detay-modal">
            <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-200 bg-orange-50">
              <div className="flex items-center gap-2 text-sm font-bold text-orange-800">
                <PackageX size={16} /> Kaliteden Geçmeyen Partiler — {row.urun_kodu} ({row.renk || "—"})
              </div>
              <button onClick={() => setOpen(false)} className="text-zinc-400 hover:text-zinc-700" data-testid="kg-detay-close"><X size={18} /></button>
            </div>
            <div className="overflow-auto p-0">
              {loading ? (
                <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={16} /> Yükleniyor...</div>
              ) : detay.length === 0 ? (
                <div className="py-10 text-center text-zinc-400">Bu ürün için kaliteden geçmeyen parti bulunamadı.</div>
              ) : (
                <table className="w-full text-sm" data-testid="kg-detay-table">
                  <thead className="bg-zinc-100 text-zinc-600 text-xs uppercase sticky top-0">
                    <tr>
                      <th className="text-left px-3 py-2">Yapılış Tarihi</th>
                      <th className="text-left px-3 py-2">Bölüm</th>
                      <th className="text-right px-3 py-2">Yapılan</th>
                      <th className="text-right px-3 py-2">Geçen</th>
                      <th className="text-right px-3 py-2">Kalan (Geçmeyen)</th>
                      <th className="text-right px-3 py-2">Geçen Gün</th>
                      <th className="text-left px-3 py-2">Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sorted.map((d, i) => (
                      <tr key={i} className={`border-t border-zinc-100 ${d.durum === "gecikmis" ? "bg-red-50 border-l-4 border-l-red-500" : ""}`} data-testid={`kg-detay-row-${i}`}>
                        <td className="px-3 py-2 mono text-zinc-600">{trTarih(d.tarih)}</td>
                        <td className="px-3 py-2">{d.bolum || "—"}</td>
                        <td className="px-3 py-2 text-right font-semibold text-indigo-700">{fmtNum(d.yapilan)}</td>
                        <td className="px-3 py-2 text-right text-zinc-700">{fmtNum(d.gecen)}</td>
                        <td className="px-3 py-2 text-right font-bold text-orange-600">{fmtNum(d.kalan)}</td>
                        <td className={`px-3 py-2 text-right font-bold ${d.durum === "gecikmis" ? "text-red-600" : "text-sky-600"}`}>{d.gecen_gun}</td>
                        <td className="px-3 py-2">
                          <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-bold ${d.durum === "gecikmis" ? "bg-red-100 text-red-700" : "bg-sky-100 text-sky-700"}`}>
                            {d.durum === "gecikmis" ? "Gecikmiş / Hatalı" : "Fırında"}
                          </span>
                          {d.durum === "gecikmis" && d.neden && <span className="block text-[10px] text-red-500 font-semibold mt-0.5">{d.neden}</span>}
                        </td>
                      </tr>
                    ))}
                    <tr className="border-t-2 border-zinc-300 bg-zinc-50 font-bold">
                      <td className="px-3 py-2" colSpan={4}>TOPLAM</td>
                      <td className="px-3 py-2 text-right text-orange-700">{fmtNum(detay.reduce((a, d) => a + (Number(d.kalan) || 0), 0))}</td>
                      <td colSpan={2}></td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
